import { GameCssStyles } from './GameCssStyles';
import { GAME_STATUS, GAME_STATUS_ARRAY, GAME_TYPE, GAME_TYPE_ARRAY } from './GameConstant';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import PredictionBasedGame from './PredictionBasedGame/PredictionBasedGame';
import FantasyLeagueGame from './FantasyGame/FantasyLeagueGame';
import SpinTheWheelGame from './SpinTheWheel/SpinTheWheelGame';

const GameTypeAndStatus = ({ formGameData, showsList, setFormGameData, handleChange }) => {

    const GameLayoutBasedOnType = (gameType) => {
        console.log("Game Type:", gameType);
        switch (gameType) {
            case 'predictionBased':
                return <PredictionBasedGame formGameData={formGameData} showsList={showsList} setFormGameData={setFormGameData} handleChange={handleChange} />;
            case GAME_TYPE.FANTASY_LEAGUE_GAME:
                return <FantasyLeagueGame formGameData={formGameData} showsList={showsList} setFormGameData={setFormGameData} handleChange={handleChange} />;
                case 'spinTheWheel':
                return <SpinTheWheelGame formGameData={formGameData} showsList={showsList} setFormGameData={setFormGameData} handleChange={handleChange} />;
            default:
                return null;
        }
    }

    const GameTypeAndStatusLayout = () => {
        return (
            <Box sx={GameCssStyles.containerStyleColumn_sx}>
                {formGameData?._id && <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game ID : {formGameData?._id}</Typography>}
                <Box sx={GameCssStyles.containerStyleRowWithoutBorder_sx}>
                    <FormControl fullWidth margin="normal">
                        <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Game Type</InputLabel>
                        <Select
                            value={formGameData?.type || ''}
                            onChange={(e) => {
                                console.log("Game Type Changed", e.target.value);
                                handleChange('type', e.target.value);
                                handleChange('status', GAME_STATUS.ACTIVE);
                            }}
                            label="Game Type"
                            sx={GameCssStyles.formFiledStyle_sx2}
                        >
                            <MenuItem value="" disabled>
                                Select Game Type
                            </MenuItem>
                            {GAME_TYPE_ARRAY?.map((item, idx) => {
                                return (<MenuItem key={idx} value={item?.value} sx={GameCssStyles.menuItemStyle_sx}> {item?.label}</MenuItem>)
                            })}
                        </Select>
                    </FormControl>

                    {/* <FormControl fullWidth margin="normal">
                        <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Status</InputLabel>
                        <Select
                            value={formGameData?.status || ''}
                            onChange={(e) => {
                                handleChange('status', e.target.value)
                            }}
                            label="Status"
                            sx={GameCssStyles.formFiledStyle_sx2}
                        >
                            <MenuItem value="" disabled>
                                Select Game Status
                            </MenuItem>
                            {GAME_STATUS_ARRAY?.map((item, idx) => {
                                return (<MenuItem
                                    key={idx}
                                    value={item?.value}
                                    sx={GameCssStyles.menuItemStyle_sx}>
                                    {item?.label}
                                </MenuItem>)
                            })}
                        </Select>
                    </FormControl> */}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            {GameTypeAndStatusLayout()}
            {GameLayoutBasedOnType(formGameData?.type)}
        </Box>
    )
}
export default GameTypeAndStatus
